module.exports = __webpack_public_path__ + "img/img_charge_phone_img5.7a0dc126.png";